var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imgCon",style:({width: _vm.comObj.width + 'px', height: _vm.comObj.height + 'px'})},[_c('img',{style:({ borderRadius: _vm.comObj.borderRadius + 'px' }),attrs:{"src":_vm.comObj.url,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }